export const appName = `products`;
